import { useMemo } from 'react';
import CopyToClipboard from '../../copyToClipboard';
import { Mail, PhoneIcon, ChevronRight } from 'assets/icons';
import AdminCollapseFile from '../../collapse/AdminCollapseFile';
import BadgeSquare from '../../badge/badgeSquare';
import Tooltip from '../../tooltips/Tooltips';
import { capitalizeFirst } from '../../../helper/helper';
import { getVisibleIdentityDocuments } from '../../../helper/identityDocuments';

const IdentityValidationMobileCard = ({
  tempWorker,
  nbFiles,
  nbFilesTotal,
  onOpenTempWorker,
}) => {
  const user = tempWorker?.user || tempWorker;
  const fullName = `${capitalizeFirst(user?.firstname)} ${capitalizeFirst(user?.lastname)}`.trim() || 'N/A';
  const email = user?.email || '';
  const phone = user?.phone || '';

  const visibleDocs = useMemo(
    () => getVisibleIdentityDocuments(tempWorker),
    [tempWorker]
  );

  return (
    <details
      className="bg-white rounded-md border border-gray-200 hover:bg-gray-50 active:bg-gray-100 transition-all duration-200 group overflow-visible"
    >
      <summary className="list-none cursor-pointer">
        <div className="p-4 pb-3">
          <div className="flex items-center justify-between gap-3">
            <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 flex-1 min-w-0">
              <Tooltip text="Voir la fiche" placement="top">
                <h3
                  className="font-semibold text-gray-900 text-base truncate cursor-pointer hover:underline decoration-dashed transition-colors max-w-[200px] md:max-w-[250px] flex-shrink-0"
                  onClick={(e) => { e.stopPropagation(); e.preventDefault(); onOpenTempWorker?.(tempWorker); }}
                  title={fullName}
                >
                  {fullName}
                </h3>
              </Tooltip>
              <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
                {email && (
                  <div className="flex items-center gap-1.5" onClick={(e) => e.stopPropagation()}>
                    <Mail wh={16} color="#6B7280" />
                    <CopyToClipboard text={email}>
                      <span className="text-gray-600 truncate max-w-[180px] md:max-w-[250px]">{email}</span>
                    </CopyToClipboard>
                  </div>
                )}
                {phone && (
                  <div className="flex items-center gap-1.5" onClick={(e) => e.stopPropagation()}>
                    <PhoneIcon wh={16} color="#6B7280" />
                    <CopyToClipboard text={phone}>
                      <span className="text-gray-600">{phone}</span>
                    </CopyToClipboard>
                  </div>
                )}
              </div>
            </div>

            <div className="flex items-center gap-2 flex-shrink-0">
              <BadgeSquare type={9} bordered customLabel={`${nbFiles}/${nbFilesTotal}`} />
              <div className="group-open:rotate-90 transition-transform flex-shrink-0">
                <ChevronRight wh={20} color="#4B5563" />
              </div>
            </div>
          </div>
        </div>
      </summary>

      <div className="px-4 pb-4 border-t border-gray-100 pt-3">
        {visibleDocs.map((doc) => (
          <AdminCollapseFile
            key={`${doc.type}-${doc.subType || doc.title}`}
            title={doc.title}
            dateAdd={doc.dateAdd}
            status={doc.status}
            type={doc.type}
            _id={tempWorker._id}
            id_user={tempWorker.id_user}
          />
        ))}
      </div>
    </details>
  );
};

export default IdentityValidationMobileCard;
